<div class="page">
    <header class="topbar">
        <div class="brand">
            <div class="brand-mark">
                <mat-icon>agriculture</mat-icon>
            </div>
            <div class="brand-text">
                <h1>Sistema de Controle Leiteiro</h1>
                <p>{{ currentViewLabel }}</p>
            </div>
        </div>

        <div class="topbar-end">
            <div class="ctrl-info">
                <span class="ctrl-avatar" aria-hidden="true">{{ controllerInitial }}</span>
                <div class="ctrl-text">
                    <p class="ctrl-name">{{ controller?.name || 'Carregando...' }}</p>
                    @if (controller?.code) {
                    <p class="ctrl-code">Código {{ controller?.code }}</p>
                    }
                </div>
            </div>
            <button type="button" mat-icon-button class="logout" aria-label="Sair" title="Sair" (click)="logoutClick.emit()">
                <mat-icon>logout</mat-icon>
            </button>
        </div>
    </header>

    <div class="body">
        <aside class="sidebar" aria-label="Seções do controlador">
            <nav>
                @for (item of views; track item.id) {
                <button
                    type="button"
                    class="nav-btn"
                    [class.active]="view === item.id"
                    [attr.aria-current]="view === item.id ? 'page' : null"
                    (click)="view = item.id"
                >
                    <mat-icon>{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                </button>
                }
            </nav>
        </aside>

        <main class="content">
            <div class="content-inner">
                <homeleite-controller-home [view]="view" (controllerChange)="controller = $event"></homeleite-controller-home>
            </div>
        </main>
    </div>
</div>
